import { InputGroup } from "@focus/focusUI";
import type { LogSeverity } from "../../../types/inputs";
import { HTMLSelect } from "@blueprintjs/core";

export type LogSortBy = "timestamp" | "severity" | "author" | "message";
export type LogSeverityFilter = "all" | LogSeverity;
export type SortDirection = "asc" | "desc";

const sortOptions: Array<{ label: string; value: LogSortBy }> = [
  { label: "Timestamp", value: "timestamp" },
  { label: "Severity", value: "severity" },
  { label: "Author", value: "author" },
  { label: "Message", value: "message" },
];

const sortDirectionOptions: Array<{ label: string; value: SortDirection }> = [
  { label: "Ascending", value: "asc" },
  { label: "Descending", value: "desc" },
];

const severityOptions: Array<{ label: string; value: LogSeverityFilter }> = [
  { label: "All", value: "all" },
  { label: "Info", value: "INFO" },
  { label: "Warn", value: "WARN" },
  { label: "Error", value: "ERROR" },
];

type InputOrbitLogsToolbarProps = {
  searchTerm: string;
  sortBy: LogSortBy;
  sortDirection: SortDirection;
  severity: LogSeverityFilter;
  total: number;
  filtered: number;
  onSearchChange: (value: string) => void;
  onSortChange: (value: LogSortBy) => void;
  onDirectionChange: (value: SortDirection) => void;
  onSeverityChange: (value: LogSeverityFilter) => void;
};

export const InputOrbitLogsToolbar = ({
  searchTerm,
  sortBy,
  sortDirection,
  severity,
  total,
  filtered,
  onSearchChange,
  onDirectionChange,
  onSortChange,
  onSeverityChange,
}: InputOrbitLogsToolbarProps) => {
  return (
    <div className="shrink-0 border-b border-slate-200 bg-white px-4 py-3">
      <div className="focusoc-form-shell flex flex-wrap items-end gap-3">
        <label className="flex min-w-[220px] flex-1 flex-col gap-1.5">
          <span className="text-xs font-semibold uppercase text-slate-500">
            Search
          </span>
          <InputGroup
            leftIcon="search"
            onChange={(event) => onSearchChange(event.target.value)}
            placeholder="Severity, author, timestamp, message..."
            value={searchTerm}
          />
        </label>

        <label className="flex min-w-[150px] flex-col gap-1.5">
          <span className="text-xs font-semibold uppercase text-slate-500">
            Severity
          </span>
          <HTMLSelect
            fill
            onChange={(event) =>
              onSeverityChange(event.target.value as LogSeverityFilter)
            }
            options={severityOptions}
            value={severity}
          />
        </label>

        <label className="flex min-w-[180px] flex-col gap-1.5">
          <span className="text-xs font-semibold uppercase text-slate-500">
            Sort by
          </span>
          <HTMLSelect
            fill
            onChange={(event) => onSortChange(event.target.value as LogSortBy)}
            options={sortOptions}
            value={sortBy}
          />
        </label>

        <label className="flex min-w-[150px] flex-col gap-1.5">
          <span className="text-xs font-semibold uppercase text-slate-500">
            Order
          </span>
          <HTMLSelect
            fill
            onChange={(event) =>
              onDirectionChange(event.target.value as SortDirection)
            }
            options={sortDirectionOptions}
            value={sortDirection}
          />
        </label>

        <span className="mb-1 rounded-full bg-slate-100 px-2.5 py-1 text-xs font-semibold uppercase text-slate-600 ring-1 ring-inset ring-slate-200">
          {filtered} / {total}
        </span>
      </div>
    </div>
  );
};
